export class RegisterUserDto {
    constructor(
        public userEmail: string,
        public userPassword: string
    ) { }
}
